import { useState } from "react";
import ApiConnector from "../../connector/ApiConnector";

const EwPayLimitLookup = () => {
  const [companyId, setCompanyId] = useState("");
  const [pan, setPan] = useState("");
  const [submittedPan, setSubmittedPan] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLookup = async (e) => {
    e.preventDefault();
    if (!companyId.trim()) return;
    setLoading(true);
    setResult(null);
    setSubmittedPan(pan.trim());
    const data = await ApiConnector.getCustomerEwPayLimit(companyId.trim(), pan.trim() || null);
    setResult(data);
    setLoading(false);
  };

  const remainingColor = result
    ? result.remainingLimit <= 0
      ? "#c0392b"
      : result.remainingLimit < result.spendingLimit * 0.2
      ? "#e67e22"
      : "#27ae60"
    : null;

  return (
    <form onSubmit={handleLookup}>
      <table className="config-table">
        <colgroup>
          <col style={{ width: "35%" }} />
          <col style={{ width: "45%" }} />
          <col style={{ width: "20%" }} />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Company ID *</td>
            <td>
              <input
                type="text"
                value={companyId}
                onChange={(e) => setCompanyId(e.target.value)}
                style={{ width: "100%", boxSizing: "border-box" }}
              />
            </td>
            <td rowSpan={2} style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>
              <button
                type="submit"
                disabled={loading || !companyId.trim()}
                style={{ height: "100%", minHeight: "54px", width: "100%", boxSizing: "border-box" }}
              >
                {loading ? "…" : "Check"}
              </button>
            </td>
          </tr>
          <tr>
            <td>PAN <span style={{ color: "#888", fontWeight: "normal" }}>(optional)</span></td>
            <td>
              <input
                type="text"
                value={pan}
                onChange={(e) => setPan(e.target.value)}
                style={{ width: "100%", boxSizing: "border-box" }}
              />
            </td>
          </tr>
          {result && (
            <>
              <tr>
                <td>Spending limit</td>
                <td colSpan={2}>{result.spendingLimit} {result.currency}</td>
              </tr>
              <tr>
                <td>Remaining limit</td>
                <td colSpan={2} style={{ color: remainingColor, fontWeight: "bold" }}>
                  {result.remainingLimit} {result.currency}
                </td>
              </tr>
              {submittedPan && !result.panSuppressed && (
                <tr>
                  <td>PAN suppressed</td>
                  <td colSpan={2} style={{ color: "#27ae60", fontWeight: "bold" }}>NO</td>
                </tr>
              )}
              {submittedPan && result.panSuppressed && (
                <tr>
                  <td>PAN suppressed</td>
                  <td colSpan={2} style={{ color: "#c0392b", fontWeight: "bold" }}>YES</td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </form>
  );
};

export default EwPayLimitLookup;
